module.exports = __webpack_public_path__ + "img/pink-carats.e50ee8da.svg";